import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Estabelecimento } from '../../model/estabelecimento';
import { ConsultaService } from '../../services/consulta.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { StorageService } from '../../services/storage.service';
import { cnpj } from "../../util/format";

@Component({
  selector: 'app-modal-adicionar-estabelecimento-filho',
  templateUrl: './modal-adicionar-estabelecimento-filho.component.html',
  styleUrls: ['./modal-adicionar-estabelecimento-filho.component.scss'],
})
export class ModalAdicionarEstabelecimentoFilhoComponent implements OnInit {

  @Input() corPrimaria: string;
  @Input() solicitacao: any;
  @Input() estabelecimento: any;
  @Input() edicao: any = false;
  config: any;
  @Output() fecharModal = new EventEmitter();
  cnesConsulta: any;
  cnpjConsulta: any;
  estabelecimentoFilho: Estabelecimento = new Estabelecimento();

  constructor(private consulta: ConsultaService,
     private loading: NgxSpinnerService,
     private toast: ToastrService,
     private storage: StorageService) {}

  ngOnInit() {
    this.config = JSON.parse(this.storage.getCurrentApp());
  }

  fechar(bol) {
    this.fecharModal.emit();
  }

  async consultarFilhos() {
    if (this.cnesConsulta || this.cnpjConsulta) {
      let estabelecimentoFilho;

      this.loading.show();
      if (this.cnpjConsulta) {
        estabelecimentoFilho = await this.consulta.consultarEstabelecimentoPorCNPJ(this.cnpjConsulta);
      } else if (this.cnesConsulta) {
        if (this.cnesConsulta == this.solicitacao.nuCnes) {
          this.toast.error('Estabelecimento filho deve ser diferente do estabelecimento cessionário');
          this.loading.hide();
          return;
        }
        estabelecimentoFilho = await this.consulta.consultarEstabelecimentoPorCNES(this.cnesConsulta);
      }

      this.loading.hide();

      if (!estabelecimentoFilho) {
        this.estabelecimentoFilho = null;
        return;
      }
      if (estabelecimentoFilho.sucesso != true) {
        this.estabelecimentoFilho = null;
        this.toast.error('Nao foi possivel encontrar este estabelecimento!');
      } else {
        estabelecimentoFilho.numeroCNPJ = cnpj(estabelecimentoFilho.numeroCNPJ);

        this.cnesConsulta = estabelecimentoFilho.codigoCNES;
        this.cnpjConsulta = estabelecimentoFilho.numeroCNPJ;

        if (this.cnpjConsulta && this.cnesConsulta == this.solicitacao.nuCnes) {
          this.toast.error('Estabelecimento filho deve ser diferente do estabelecimento cessionário');
          return;
        }

        this.estabelecimentoFilho = estabelecimentoFilho;
      }
    } else {
      this.toast.error('Preencha o campo CNES ou CNPJ');
    }



    // if (this.cnesConsulta != this.solicitacao.nuCnes) {
    //   if (this.cnesConsulta) {
    //     this.loading.show();
    //     this.estabelecimentoFilho = await this.consulta.consultarEstabelecimentoPorCNES(
    //       this.cnesConsulta
    //     );
    //     this.loading.hide();
    //     if (this.estabelecimentoFilho.sucesso != true) {
    //       this.toast.error('Nao foi possivel encontrar este estabelecimento!');
    //     }
    //   } else {
    //     this.toast.error('Preencha o campo CNES');
    //   }
    // } else {
    //   this.toast.error('Estabelecimento filho deve ser diferente do estabelecimento cessionário');
    // }
  }


  adicionar() {
    if (!this.estabelecimentoFilho.codigoCNES) {
      this.toast.error('Preencha o campo CNES');
      return;
    }

    if (this.estabelecimentoFilho.siglaUF.toLowerCase() != this.estabelecimento.siglaUF.toLowerCase()) {
      this.toast.error('Estabelecimento filho deve ser da mesma UF do estabelecimento cessionário');
      return;
    }
    let index = this.solicitacao.estabelecimentosFilhos.findIndex((item => {
      return item.nuCnes == this.estabelecimentoFilho.codigoCNES;
    }));
    if (index != -1) {
      this.toast.error('Estabelecimento filho já adicionado.');
      return;
    }

    this.fecharModal.emit({
      nuCnes: this.estabelecimentoFilho.codigoCNES,
      nomeFantasia: this.estabelecimentoFilho.nomeFantasia,
      codigoMunicipio: this.estabelecimentoFilho.codigoMunicipio,
      codigoUF: this.estabelecimentoFilho.codigoUF,
      siglaUf: this.estabelecimentoFilho.siglaUF
    });

  }


}



// WEBPACK FOOTER //
// ./src/app/components/modal-adicionar-estabelecimento-filho/modal-adicionar-estabelecimento-filho.component.ts